import request from '../../../../../../services/request'
import { getPaymentOperationsFile } from '../../configurations'
import { message } from 'antd'
import { IOperation } from './types'

export interface IPaymentOperationsPayload {
    fee: string
    price_fee: string
    price: string
    operations: IOperation[]
}

export const downloadPaymentOperationsFile = async (
    payload: IPaymentOperationsPayload,
): Promise<void> => {
    try {
        const response = await request.post(getPaymentOperationsFile.link, payload, {
            responseType: 'blob',
        })

        const disposition = response.headers['content-disposition']
        const filenameMatch = disposition?.match(/filename="?([^"]+)"?/)
        let filename = filenameMatch?.[1] || 'payment_operations_report'
        if (!filename.endsWith('.xlsx')) {
            filename += '.xlsx'
        }

        const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        })
        const objectUrl = window.URL.createObjectURL(blob)

        const anchor = document.createElement('a')
        anchor.style.display = 'none'
        document.body.appendChild(anchor)
        anchor.href = objectUrl
        anchor.download = filename
        anchor.click()

        window.URL.revokeObjectURL(objectUrl)
        document.body.removeChild(anchor)
    } catch (error: any) {
        console.error(error)
        message.error('Не удалось скачать файл результатов расчета')
    }
}
